import fscreen from 'fscreen';
import isMobile from 'ismobilejs';
import { detect } from 'detect-browser';

/**
 * Simple plugin to handle fullscreen toggling
 */
const FullscreenPlugin = {
    install(Vue: any) {
        const notifiyFns: Function[] = [];

        /**
         * Determines if fullscreen is active
         */
        let isFullscreen = false;
        /**
         * Toggles fullscreen programmatically
         */
        const toggleFullscreen = async () => {
            // check if fullscreen feature is available
            if (fscreen.fullscreenEnabled) {
                try {
                    if (!isFullscreen) {
                        const appElement = document.getElementById('app');
                        await fscreen.requestFullscreen(appElement!);
                    } else {
                        await fscreen.exitFullscreen();
                    }
                } catch (e) {
                    // full screen request / exit rejected
                    console.error(e);
                }
            }
        };

        /**
         * Functions that will get a notify if fullscreen state changes
         * @param fn
         */
        const addOnFullscreenChangeNotifyFn = (fn: Function) => {
            notifiyFns.push(fn);
        };

        fscreen.onfullscreenchange = () => {
            isFullscreen = !isFullscreen;
            // notify all observers
            notifiyFns.forEach(fn => fn(isFullscreen));
        };

        /**
         *  Determines if fullscreen api is available
         */
        const isMobileValue = isMobile(window.navigator).any;
        const browser = detect();
        const browserExceptions = ['safari', 'ios'];
        const isFullscreenAvailable = fscreen.fullscreenEnabled && browser && !(browserExceptions.includes(browser!.name) && isMobileValue);

        /**
         * Fullscreen functions
         */
        const fullscreenFns = {
            toggleFullscreen,
            addOnFullscreenChangeNotifyFn,
            isFullscreenAvailable
        };

        Vue.prototype.$fullscreen = fullscreenFns;
        Vue.fullscreen = fullscreenFns;
    }
};
export default FullscreenPlugin;
